module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_f_albino.1f5067d1.png";